export default __webpack_public_path__ + "static/media/user-icon.6f8e57a0.svg";